"use strict";

import angular from "angular";

import _ from "lodash";
import { Validations } from "../../imports/validations";

export class NavigationServiceProvider {
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
        this.$state = this.$stateProvider.stateService;
        this.items = [];
        this.params = {};
    }

    setItem(item) {
        const submenu = Array.isArray(item.submenu)
            ? item.submenu.map((sub) => ({
                  title: sub.title,
                  uisref: sub.uisref,
                  cancelredirect: sub.cancelredirect,
                  uisrefparams: sub.uisrefparams,
                  icon: sub.icon,
                  image: sub.image,
                  permission: sub.permission,
                  flag: sub.flag,
                  available: sub.available,
                  activeStates: sub.activeStates,
                  mediaQuery: sub.mediaQuery,
                  customHref: sub.customHref,
                  contract: sub.contract,
                  badgeContract: sub.badgeContract,
                  accountingPlan: sub.accountingPlan,
                  htmlId: sub.htmlId
              }))
            : undefined;
        this.items.push({
            title: item.title,
            uisref: item.uisref,
            cancelredirect: item.cancelredirect,
            uisrefparams: item.uisrefparams,
            icon: item.icon,
            image: item.image,
            permission: item.permission,
            hidden: item.hidden,
            flag: item.flag,
            available: item.available,
            position: item.position,
            activeStates: item.activeStates,
            mediaQuery: item.mediaQuery,
            group: item.group,
            customHref: item.customHref,
            contract: item.contract,
            badgeContract: item.badgeContract,
            accountingPlan: item.accountingPlan,
            htmlId: item.htmlId,
            submenu
        });
    }

    setValidations() {
        const apply = (navItem) => {
            if (
                typeof navItem.flag === "undefined" ||
                _.get(navItem.flag, "length") === 0
            )
                return (navItem.hidden = false);
            navItem.hidden = !Validations.userIs(navItem.flag);
        };
        this.items.forEach((item) => {
            apply(item);
            if (item.submenu) item.submenu.forEach(apply);
        });
    }

    setValidationsContract(accountingPlanEntity) {
        const _isEmpty = (navItem, path) =>
            typeof _.get(navItem, `accountingPlan.${path}`) === "undefined";

        const applyContract = (navItem) => {
            if (
                _isEmpty(navItem, "feature") &&
                _isEmpty(navItem, "module.name")
            )
                navItem.contracted = true;
            else {
                const isContractedModule = navItem.accountingPlan?.module
                    ?.source
                    ? accountingPlanEntity.isContractedModule({
                          value: navItem?.accountingPlan?.module?.name,
                          source: navItem?.accountingPlan?.module?.source
                      })
                    : accountingPlanEntity.isContractedModuleByValue({
                          value: navItem?.accountingPlan?.module?.name
                      });
                navItem.contracted =
                    accountingPlanEntity.isContractedFeature({
                        value: navItem?.accountingPlan?.feature
                    }) || isContractedModule;
            }
        };

        this.items.forEach((item) => {
            applyContract(item);
            if (item.submenu) item.submenu.forEach(applyContract);
        });
    }

    setAvailables(stateCurrentName) {
        const applyAvailable = (navItem) => {
            if (!navItem.available) return;
            const index = navItem.available.findIndex((state) => {
                const stateAvailable = state.split("*");
                if (stateAvailable.length === 1)
                    return state === stateCurrentName;
                return stateCurrentName.indexOf(stateAvailable[0]) > -1;
            });
            navItem.show = index > -1;
        };
        this.items.forEach((item) => {
            applyAvailable(item);
            if (item.submenu) item.submenu.forEach(applyAvailable);
        });
    }

    setDisabled(states) {
        states.forEach((state) => {
            this.items.forEach((item) => {
                if (item.uisref === state) item.disabled = true;
                if (item.submenu) {
                    item.submenu.forEach((sub) => {
                        if (sub.uisref === state) sub.disabled = true;
                    });
                }
            });
        });
    }

    setEnabled(states) {
        states.forEach((state) => {
            this.items.forEach((item) => {
                if (item.uisref === state) item.disabled = false;
                if (item.submenu) {
                    item.submenu.forEach((sub) => {
                        if (sub.uisref === state) sub.disabled = false;
                    });
                }
            });
        });
    }

    setParams(key, value) {
        this.params[key] = value;
    }

    setHref() {
        const buildHref = (navItem) => {
            if (!navItem.uisref) return;
            const params = {};
            if (navItem.uisrefparams) {
                navItem.uisrefparams.forEach((param) => {
                    params[param] = this.params[param];
                });
            }
            navItem.href = this.$state.href(navItem.uisref, params);
        };
        this.items.forEach((item) => {
            buildHref(item);
            if (item.submenu) item.submenu.forEach(buildHref);
        });
    }

    getItems() {
        return this.items;
    }

    $get() {
        return {
            setItem: this.setItem,
            setDisabled: this.setDisabled,
            setEnabled: this.setEnabled,
            getItems: this.getItems,
            items: this.items,
            setValidations: this.setValidations,
            setAvailables: this.setAvailables,
            setValidationsContract: this.setValidationsContract,
            setParams: this.setParams,
            params: this.params,
            setHref: this.setHref,
            $state: this.$state
        };
    }
}

angular
    .module("nucont.shared")
    .provider("NavigationService", [
        "$stateProvider",
        NavigationServiceProvider
    ]);
